import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Auth.css";
import { handleLogin, handleAdminLogin } from "../utils/authUtils";
import logo from "../images/logo.png";

const AuthForms = ({ isAdmin = false }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      const result = isAdmin
        ? await handleAdminLogin(formData)
        : await handleLogin(formData);

      if (result.success) {
        // Redirect to appropriate dashboard
        navigate(isAdmin ? "/admin/dashboard" : "/dashboard");
      } else {
        setErrors(result.errors || { general: "Login failed" });
      }
    } catch (error) {
      setErrors({ general: "An error occurred. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Logo */}
      <div className="auth-logo">
        <img src={logo} alt="Investec Logo" />
      </div>

      <div className="auth-container">
        <div className="auth-background"></div>

        <div className="auth-content">
          <div className="auth-card">
            {/* Welcome Text */}
            <h1 className="auth-title">Welcome to Investec Online</h1>

            {/* Login Form */}
            <form onSubmit={handleSubmit} className="auth-form">
              {/* General Error */}
              {errors.general && (
                <div className="error-banner">{errors.general}</div>
              )}

              {/* Email/ID Input */}
              <div className="form-group">
                <input
                  type="text"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Investec ID"
                  className={`form-input ${errors.email ? "error" : ""}`}
                  autoComplete="username"
                />
                {errors.email && (
                  <span className="error-text">{errors.email}</span>
                )}
              </div>

              {/* Password Input */}
              <div className="form-group">
                <div className="password-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Investec password"
                    className={`form-input ${errors.password ? "error" : ""}`}
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? "Hide" : "Show"}
                  </button>
                </div>
                {errors.password && (
                  <span className="error-text">{errors.password}</span>
                )}
              </div>

              {/* Remember Me */}
              <div className="form-group checkbox-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="rememberMe"
                    checked={formData.rememberMe}
                    onChange={handleChange}
                    className="checkbox-input"
                  />
                  <span className="checkbox-text">Remember my Investec ID</span>
                </label>
              </div>

              {/* Trouble Logging In & Submit */}
              <div className="form-actions">
                <button
                  type="button"
                  className="link-button"
                  onClick={() => navigate("/forgot-password")}
                >
                  Trouble logging in?
                </button>
                <button
                  type="submit"
                  className="submit-button"
                  disabled={loading}
                >
                  {loading ? "Logging in..." : "Log in"}
                </button>
              </div>

              {/* Terms */}
              <div className="terms-text">
                By logging in to Investec Online, you are confirming that you
                have read and agreed to the{" "}
                <a
                  href="https://investecs.co.za/legal/terms-and-conditions.html"
                  className="terms-link"
                >
                  terms and conditions
                </a>{" "}
                applicable to dealing with Investec over the internet.
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthForms;
